import React, { useState } from 'react';
import Heart from "react-animated-heart";
import { useAddFoodLikeMutation, useGetLikeFoodQuery, useDeleteFoodLikeMutation } from '../redux/services/foods/foodAPI ';
import Swal from 'sweetalert2';
import queryString from 'query-string';
import { useAddOrderMutation } from '../redux/services/foods/orderAPI';
import { useGetCartQuery } from '../redux/services/userPnael/userPnaelAPI';

const getUserId = (user) => user?.id || user?.user?.id;

function Food({ food, condition, user, onClose }) {
  const userId = getUserId(user);
  const { data: cart, refetch: Cartrefetch } = useGetCartQuery(userId);
  const foodIdExists = cart?.orders?.some((order) => order.food.id === food.id);

  const [addLike, { error: likeError, isError: likeIsError }] = useAddFoodLikeMutation();
  const [addOrder, { error, isError }] = useAddOrderMutation();
  const { data: foodLikes, refetch } = useGetLikeFoodQuery();
  const [deleteFoodLike] = useDeleteFoodLikeMutation();
  const [imageLoaded, setImageLoaded] = useState(false);

  const isFind = (id) => cart?.orders?.some((element) => element?.food.id === id);

  const addToOrder = async () => {
    try {
      await Cartrefetch();
      if (isError) {
        Swal.fire({
          icon: 'error',
          text: error?.data || 'Unable to place order.',
          customClass: { popup: 'sweetalert2-custom-popup' },
        });
        return;
      }

      if (await isFind(food.id)) {
        Swal.fire({
          icon: 'warning',
          text: 'You have already ordered this food.',
          customClass: { popup: 'sweetalert2-custom-popup' },
        });
        return;
      }

      const response = await addOrder(queryString.stringify({
        foods_number: 1,
        Client: userId,
        food: food.id,
      }));

      await Cartrefetch();

      if (response?.data) {
        Swal.fire({
          icon: 'success',
          text: response.data.message,
          timer: 1500,
          showConfirmButton: false,
          customClass: { popup: 'sweetalert2-custom-popup' },
        });
      } else if (response?.error?.data) {
        Swal.fire({
          icon: 'warning',
          text: response.error.data.message || 'Unable to place order.',
          customClass: { popup: 'sweetalert2-custom-popup' },
        });
      } else {
        Swal.fire({
          icon: 'warning',
          text: 'Unknown error occurred.',
          customClass: { popup: 'sweetalert2-custom-popup' },
        });
      }
    } catch {
      Swal.fire({
        icon: 'info',
        html: 'You have to <b><a href="/login">Login</a></b> or <b><a href="/register">Register</a></b> first.',
        confirmButtonText: 'Got it',
        customClass: { popup: 'sweetalert2-custom-popup' },
      });
    }
  };

  const handleLike = async () => {
    if (!user) {
      Swal.fire({
        icon: 'info',
        html: 'Please <a href="/login">login</a> to save favorites.',
        confirmButtonText: 'Got it',
        customClass: { popup: 'sweetalert2-custom-popup' },
      });
      return;
    }

    if (likeIsError) {
      Swal.fire({
        icon: 'error',
        text: likeError?.data || 'Favorite action failed.',
        confirmButtonText: 'Try again',
        customClass: { popup: 'sweetalert2-custom-popup' },
      });
      return;
    }

    const like = foodLikes?.find((item) => Number(item?.user_liked) === Number(userId) && Number(item?.food) === Number(food.id));

    if (like) {
      await deleteFoodLike(like.id);
      await refetch();
      Swal.fire({
        icon: 'success',
        text: 'Removed from favourites',
        timer: 1200,
        showConfirmButton: false,
        toast: true,
        position: 'top-end',
        customClass: { popup: 'sweetalert2-toast-custom' },
      });
    } else {
      const response = await addLike(queryString.stringify({
        food: parseInt(food.id, 10),
        user_liked: userId,
      }));

      if (response?.data) {
        await refetch();
        Swal.fire({
          icon: 'success',
          text: response.data.message,
          width: 400,
          timer: 1600,
          showConfirmButton: false,
          customClass: { popup: 'sweetalert2-custom-popup' },
        });
      } else {
        Swal.fire({
          icon: 'warning',
          text: response?.error?.data?.message || 'Unable to save favorite.',
          confirmButtonText: 'OK',
          customClass: { popup: 'sweetalert2-custom-popup' },
        });
      }
    }
  };

  const liked = foodLikes?.some((like) => Number(like?.user_liked) === Number(userId) && Number(like?.food) === Number(food.id));
  const ingredients = food.food_content || [];

  const card = (
    <div className="premium-card bg-white p-5 sm:p-6">
      <div className="flex flex-col gap-6 sm:flex-row">
        <div className="relative mx-auto shrink-0 sm:mx-0">
          <div className="absolute -inset-3 rounded-3xl bg-amber-100 blur-xl" />
          <div className="relative overflow-hidden rounded-3xl bg-slate-50 p-3">
            {!imageLoaded && (
              <div className="absolute inset-0 grid place-items-center bg-slate-100">
                <div className="h-8 w-8 animate-spin rounded-full border-4 border-amber-300 border-t-amber-600" />
              </div>
            )}
            <img
              className={`h-24 w-full object-contain transition duration-500 ${imageLoaded ? "opacity-100" : "opacity-0"} sm:h-64`}
              src={food.food_img}
              alt={food.name}
              onLoad={() => setImageLoaded(true)}
              loading="lazy"
            />
          </div>
        </div>

        <div className="flex-1">
          <div className="flex items-start justify-between gap-4">
            <div>
              <p className="text-sm font-bold uppercase tracking-wide text-amber-600">
                Restaurant Ordering
              </p>
              <h2 className="mt-2 text-2xl font-black tracking-tight text-ink">
                {food.name}
              </h2>
            </div>
            {userId && (
              <button
                type="button"
                onClick={handleLike}
                // className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-slate-50 p-1.5 shadow-sm transition hover:bg-amber-50 focus:outline-none focus:ring-4 focus:ring-amber-100"
                aria-label={
                  liked ? "Remove from favorites" : "Add to favorites"
                }
              >
                <Heart isClick={liked} />
              </button>
            )}
          </div>

          {food.description && (
            <p className="mt-4 leading-7 text-muted">{food.description}</p>
          )}

          {ingredients.length > 0 && (
            <div className="mt-5 rounded-3xl bg-slate-50 p-4">
              <p className="text-sm font-black uppercase tracking-wide text-muted">
                Ingredients
              </p>
              <div className="mt-3 grid gap-2 sm:grid-cols-2">
                {ingredients.map((content, idx) => (
                  <div
                    key={`${content.name}-${idx}`}
                    className="flex items-center justify-between rounded-2xl bg-white px-3 py-2 text-sm"
                  >
                    <span className="font-bold text-ink">{content.name}</span>
                    <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs font-bold text-muted">
                      {content.grams_weight}gr
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <p className="text-xs font-bold uppercase tracking-wide text-muted">
                Total price
              </p>
              <p className="text-3xl font-black text-ink">${food.price}</p>
            </div>
            {userId && (
              <>
                {foodIdExists ? (
                  <div className="inline-flex items-center justify-center rounded-2xl bg-emerald-50 px-5 py-3 text-sm font-black text-emerald-700">
                    In your cart
                  </div>
                ) : (
                  <button
                    type="button"
                    onClick={addToOrder}
                    className="btn-primary"
                  >
                    Add to cart
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  if (condition) {
    const handleBackdropClick = () => (onClose || (() => window.history.back()))();
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/70 p-4 backdrop-blur-sm" onClick={handleBackdropClick}>
        <div className="relative w-full max-w-5xl" onClick={(e) => e.stopPropagation()}>
          <button type="button" onClick={onClose || (() => window.history.back())} className="absolute -right-2 -top-2 z-10 grid h-11 w-11 place-items-center rounded-full bg-white text-ink shadow-xl transition hover:bg-red-50 hover:text-red-600 focus:outline-none focus:ring-4 focus:ring-red-100" aria-label="Close food details">
            <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          {card}
        </div>
      </div>
    );
  }

  return card;
}

export default Food;